import React from "react";

const Input = ({ label, name, data, errors, ...rest }) => {
  return (
    <>
      <div
        className={`input-wrapper d-flex flex-row align-items-center ${
          errors[name] ? "mb-1" : "mb-3"
        } mb-md-0`}
      >
        <label htmlFor="card_name" className="mb-0">
          {label}
        </label>
        <input
          name={name}
          value={data[name] || ""}
          className="form-control"
          {...rest}
        />
      </div>
      <InputError error={errors[name]} />
    </>
  );
};

const InputError = ({ error }) => {
  return (
    <>
      {error && error !== "NOT_EMPTY" ? (
        <p className="text-danger small mb-3 mb-md-0">{error}</p>
      ) : null}
    </>
  );
};

const cardStyle = {
  base: {
    fontSize: "16px",
    lineHeight: 1,
    color: "#495057",
    fontFamily: '"Lato", sans-serif',
    display: "block",
    width: "auto",
    fontWeight: 400,
    backgroundColor: "#fff",
    backgroundClip: "padding-box",
    border: "0 solid #ced4da",
    borderRadius: "0.25rem",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    flex: 1,
    "::placeholder": {
      color: "#6c757d"
    }
  },
  invalid: {
    color: "#dc3545",
    fontWeight: 300
  }
};

const CardElementInput = ({
  label,
  name,
  data,
  errors,
  component: Component,
  half,
  ...rest
}) => {
  return (
    <>
      <div
        className={`input-wrapper d-flex flex-row align-items-center ${
          half ? "input-wrapper-half" : null
        }`}
      >
        <label htmlFor="card_name" className="mb-0">
          {label}
        </label>
        <Component style={cardStyle} {...rest} />
      </div>
      <InputError error={errors[name]} />
    </>
  );
};

export { Input, InputError, CardElementInput };
